import Loader from "./Loader"
import { Loading } from "./Loading";;
export {
    Loader,
    Loading
} ;
